var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-sc-1-com"},[_c('div',{staticClass:"close",on:{"click":_vm.close}},[_c('img',{attrs:{"src":require("@/assets/test/part-close.png"),"alt":""}})]),_c('div',{staticClass:"table-wrapper-1"},[_c('UpDownCustomerNetWork',{attrs:{"type":"2","close":"2"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }